<template>
    <Wrapper fullscreen :hero-img="model.media?.hero_image?.lg" :theme="model.appearance">
        <div class="container">
            <Breadcrumb :items="breadcrumbItems" />

            <div class="grid grid-cols-12 base-responsive-gap mt-6">
                <div class="col-span-12" :class="googleCalendarUrl ? '' : 'lg:col-span-7'">
                    <div class="mb-4 flex flex-col sm:flex-row justify-between">
                        <h1 class="header-1">{{ model.title }}</h1>
                        <div v-if="googleCalendarUrl" class="mt-4 mb-8 sm:mb-0 sm:mt-0">
                            <div>
                                <div class="flex items-center">
                                    <i class="pi pi-calendar text-xl"></i>
                                    <div class="uppercase ml-4"><T t="event.save_to_calendar" /></div>
                                    <div class="flex ml-2">
                                        <a
                                            :href="googleCalendarUrl"
                                            target="_blank"
                                            class="w-10 h-10 bg-contain bg-center bg-no-repeat ml-5"
                                            :style="`background-image: url(${require('~/assets/images/icons/google.png')})`"
                                        ></a>
                                    </div>
                                </div>
                            </div>

                            <div class="border-t-[1px] border-gray-600 pt-4 mt-4">
                                <a
                                    class="flex items-start event-cta"
                                    :href="`https://www.facebook.com/sharer/sharer.php?u=${
                                        $config.siteBaseURL + $route.fullPath
                                    }`"
                                    target="_blank"
                                >
                                    <i class="pi pi-share-alt text-xl"></i>
                                    <span class="uppercase ml-4">
                                        <T t="event.share" />
                                    </span>
                                </a>
                            </div>

                            <div class="mt-5">
                                <Button
                                    to="https://ligetplusz.hu/jegyek/mental-liget-a-munkahelyi-mentalis-egeszseg-foruma-lkp-2026-0518"
                                    target="_blank"
                                    :label="$t('generic.purchase_ticket')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <EditableContentComponentGroup :components="model.components" compact class="mt-4 lg:mt-12" />
    </Wrapper>
</template>

<script>
import EditableContentComponentGroup from '@/components/Generic/EditableContentComponentGroup.vue';
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';

export default {
    name: 'ContentPage',
    components: { Wrapper, EditableContentComponentGroup },
    async asyncData({ $axios, params, i18n, redirect, localePath }) {
        let model = null;

        await $axios
            .$get(`/articles/by-slug/${params.slug}`)
            .then((res) => {
                model = res;
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('index'));
        }

        await i18n.generateLocalizedRouteParams(model.locale_variants, 'slug');

        const breadcrumbItems = [];

        breadcrumbItems.push([model.title, 'slug']);

        return {
            breadcrumbItems,
            model,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
    computed: {
        googleCalendarUrl() {
            if (this.$route.path !== '/mental-liget-forum-a-munkahelyi-mentalis-egeszseg-foruma') {
                return;
            }
            return this.$generateGoogleCalendarUrl({
                title: 'Mentál Liget Fórum',
                details: 'Munkahelyi mentális jóllét: érdekközösség és határhúzás',
                startDate: '2026-05-18 10:00:00',
                endDate: '2026-05-18 20:00:00',
            });
        },
    },
};
</script>

<style scoped>
.event-cta:hover span {
    @apply underline;
}
</style>
